import { render, staticRenderFns } from "./PosterShop.vue?vue&type=template&id=7ccbe59b&scoped=true&"
import script from "./PosterShop.vue?vue&type=script&lang=js&"
export * from "./PosterShop.vue?vue&type=script&lang=js&"
import style0 from "./PosterShop.vue?vue&type=style&index=0&id=7ccbe59b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccbe59b",
  null
  
)

export default component.exports